<template>
<div class="md-layout">
    <div class="md-layout-item">
        <md-card>
            <header-form title="MOTORISTAS DO CARRO" :rota="{name: 'carrosRead'}" tooltip="Lista de Carros" />

            <md-card-content>
                <div class="md-layout">
                    <div class="md-layout-item md-size-100 md-xsmall-size-100">
                        <md-tabs class="md-info mdTabs">
                            <md-tab v-if="permissoes.carrosRemoveMotorista" id="tab-niveis" md-label="Motoristas" md-icon="person">
                                <md-table v-model="searchedDelete" md-card @md-selected="selectDelete" md-fixed-header>
                                    <md-table-toolbar>
                                        <div class="md-toolbar-section-start"></div>
                                        <md-field md-clearable class="md-toolbar-section-end">
                                            <md-input placeholder="Pesquise aqui por empresa ou grupo de empresas" v-model="search" @input="searchOnTableCarroMotorista" />
                                        </md-field>
                                    </md-table-toolbar>

                                    <md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="multiple" md-auto-select class="tableRow">
                                        <md-table-cell style="width: 5%" md-numeric>{{ item.id }}</md-table-cell>
                                        <md-table-cell class="uppercase" style="width: 50%">{{ item.nome }}</md-table-cell>
                                        <md-table-cell class="uppercase" style="width: 45%">{{ item.empresa }}</md-table-cell>
                                    </md-table-row>
                                </md-table>
                                <md-card-actions class="cardActions">
                                    <div class="md-toolbar-section-start">
                                        <h3 class="uppercase text-secondary"><strong>{{ carro.nome }}</strong></h3>
                                    </div>
                                    <md-button @click="removeMotorista" class="md-danger md-round">
                                        <span class="md-label">
                                            <md-icon class="material-icons">delete</md-icon>
                                        </span>EXCLUIR
                                    </md-button>
                                </md-card-actions>
                            </md-tab>

                            <md-tab v-if="permissoes.carrosAddMotorista" id="tab-add-niveis" md-label="Adicionar Motoristas" md-icon="person_add">
                                <md-table v-model="searchedAdd" md-card @md-selected="selectAdd" md-fixed-header>
                                    <md-table-toolbar>
                                        <div class="md-toolbar-section-start"></div>
                                        <md-field md-clearable class="md-toolbar-section-end">
                                            <md-input placeholder="Pesquise aqui por empresa ou grupo de empresas" v-model="search" @input="searchOnTableMotoristas" />
                                        </md-field>
                                    </md-table-toolbar>

                                    <md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="multiple" md-auto-select class="tableRow">
                                        <md-table-cell md-label="ID" style="width: 5%" md-sort-by='id' md-numeric>{{ item.id }}</md-table-cell>
                                        <md-table-cell class="uppercase" md-label="NOME" style="width: 50%" md-sort-by="razao_social">{{ item.nome }}</md-table-cell>
                                        <md-table-cell class="uppercase" md-label="EMPRESA" style="width: 45%">{{ item.empresa }}</md-table-cell>
                                    </md-table-row>
                                </md-table>
                                <md-card-actions class="cardActions">
                                    <div class="md-toolbar-section-start">
                                        <h3 class="uppercase text-secondary"><strong>{{ carro.nome }}</strong></h3>
                                    </div>
                                    <md-button @click="adicionarEmpresas" class="md-success md-round">
                                        <span class="md-label">
                                            <md-icon class="material-icons">add</md-icon>
                                        </span>ADICIONAR
                                    </md-button>
                                </md-card-actions>
                            </md-tab>
                        </md-tabs>
                    </div>
                </div>
            </md-card-content>

        </md-card>
    </div>
</div>
</template>

<script>
import Notify from '@/config/mixins/notify'
import preLoader from '@/config/mixins/preLoader';
import HeaderForm from '@/pages/Layout/Extra/HeaderForm'

const toLower = text => {
    return text.toString().toLowerCase()
}

const searchByName = (items, term) => {
    if (term) {
        return items.filter(item => toLower([item.nome, item.empresa]).includes(toLower(term)))
    }

    return items
}

export default {
    name: 'UsuarioReadEmpresa',
    components: {
        HeaderForm
    },

    mixins: [Notify, preLoader],

    data() {
        return {
            dados: {},
            carro: {},
            permissoes: this.$store.state.usuario.permissao,
            motoristasCarro: [],
            motoristas: [],
            deleteMotorista: [],
            addMotorista: [],
            search: null,
            searchedDelete: [],
            searchedAdd: []
        };
    },

    created() {
        this.getMotorista()
        this.searchedDelete = this.motoristasCarro
        this.searchedAdd = this.motoristas
    },

    methods: {
        getMotorista() {
            this.$http.get(this.$urlAPI + 'carros/motoristas/' + this.$route.params.id)
                .then(response => {
                    if (response.data.status) {
                        this.carro = response.data.carro;
                        this.motoristasCarro = response.data.dados;
                        this.motoristas = response.data.motoristas;
                        this.searchedDelete = response.data.dados
                        this.searchedAdd = response.data.motoristas
                    } else {
                        this.danger(response.data.message)
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
        },

        searchOnTableCarroMotorista() {
            this.searchedDelete = searchByName(this.motoristasCarro, this.search)
        },

        searchOnTableMotoristas() {
            this.searchedAdd = searchByName(this.motoristas, this.search)
        },

        selectDelete(items) {
            let item = []
            items.forEach(element => {
                item.push(element.id)
            });
            this.deleteMotorista = item
        },

        selectAdd(items) {
            let item = []
            items.forEach(element => {
                item.push(element.id)
            });
            this.addMotorista = item
        },

        removeMotorista() {
            if (this.deleteMotorista.length === 0) {
                return this.warning('Selecione pelo menos um Motorista antes de excluir!')
            }
            this.dados.id = this.carro.id
            this.dados.motorista = this.deleteMotorista
            this.$http.post(this.$urlAPI + 'carros/remove-motorista', this.dados)
                .then(response => {
                    if (response.data.status) {
                        this.carro = response.data.carro;
                        this.motoristasCarro = response.data.dados;
                        this.motoristas = response.data.motoristas;
                        this.searchedDelete = response.data.dados
                        this.searchedAdd = response.data.motoristas
                        this.success(response.data.message)
                    } else {
                        this.danger(response.data.message)
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
        },

        adicionarEmpresas() {
            if (this.addMotorista.length === 0) {
                return this.warning('Selecione pelo menos um Motorista antes de adicionar!')
            }
            this.dados.id = this.carro.id
            this.dados.motorista = this.addMotorista
            this.$http.post(this.$urlAPI + 'carros/motorista', this.dados)
                .then(response => {
                    if (response.data.status) {
                        this.carro = response.data.carro;
                        this.motoristasCarro = response.data.dados;
                        this.motoristas = response.data.motoristas;
                        this.searchedDelete = response.data.dados
                        this.searchedAdd = response.data.motoristas
                        this.success(response.data.message)
                    } else {
                        this.danger(response.data.message)
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
        }
    },
}
</script>

<style lang="scss" scoped>
.md-tab {
    margin-top: -50px !important;
}

.mdTabs {
    margin-top: 30px;
}
</style>
